const LocalStorageKeys = {
	AUTH: 'AUTH',
	SIGNUP_EMAIL: 'SIGNUP_EMAIL',
	DeviceId: 'DeviceId',
}

export default LocalStorageKeys
